import {
  View,
  Image,
  Text,
  Alert,
  Switch,
  TextInput,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  Modal,
} from "react-native";
import React, { useEffect, useState } from "react";
import { SafeAreaView } from "react-native-safe-area-context";

import CheckBox from "expo-checkbox";
import styles from "../../../styles/styles";
import { setRelationshipHook } from "../../../../../redux/profile/profileSlice";
import { dispatch } from "../../../../../redux/store";
import editProfileStyle from "../../../styles/editProfileStyle";
import settingsStyle from "../../../styles/settingsStyle";
import FeedIcons from "../../../../../assets/Icons/FeedIcons";
import GlobalStyles from "../../../../../globalStyles/globalStyles";

const CircleDesign = () => {
  return (
    <View style={[styles.optionCircle, styles.optionOnSelect]}>
      <View style={styles.optionCircleInner}></View>
    </View>
  );
};

export default function EditRelationship({
  navigation,
  route,
}: {
  navigation: any;
  route: any;
}) {
  const { staticData, setStaticData } = route.params;
  const [relationship, setRelationship] = useState("");
  const [toggleCheckBox, setToggleCheckBox] = useState(false);
  useEffect(() => {
    // dispatch(setRelationshipHook(relationship));
  }, [relationship]);

  return (
    <SafeAreaView
      style={{
        backgroundColor: "white",
        width: "100%",
        display: "flex",
        alignItems: "center", height: "100%",
      }}
    >
      <View style={editProfileStyle.stickTopBar}>
        <View style={editProfileStyle.backBoxMain}>
          <View style={[settingsStyle.backBox, { }]}>
            <TouchableOpacity onPress={() => navigation.goBack()}>
              {/* <Image source={Icons.Back} /> */}
              <FeedIcons.BackIcon />
            </TouchableOpacity>
            <Text style={GlobalStyles.heading3}>Relationship status</Text>
          </View>
        </View>
      </View>
      <View style={{ backgroundColor: "white", width: "90%", height: "90%" }}>
        <View>
          <View style={styles.middleScreen}>
            {/* <Text style={styles.selectGender}>Which gender best discribe you?</Text> */}
            <View style={styles.optionBox}>
              <TouchableOpacity
                onPress={() => {
                  setRelationship("Single");
                  setStaticData((prev: any) => {
                    return {
                      ...prev,
                      userInfo: {
                        ...prev.userInfo,
                        relationshipStatus: "Single",
                      },
                    };
                  });
                }}
              >
                <View style={styles.optionBoxInnerBox}>
                  <Text style={[GlobalStyles.bodyText, styles.optionText]}>Single</Text>
                  {relationship == "Single" ? (
                    <CircleDesign />
                  ) : (
                    <View style={styles.optionCircle}></View>
                  )}
                </View>
              </TouchableOpacity>

              <TouchableOpacity
                onPress={() => {
                  setRelationship("Relationship");
                  setStaticData((prev: any) => {
                    return {
                      ...prev,
                      userInfo: {
                        ...prev.userInfo,
                        relationshipStatus: "Relationship",
                      },
                    };
                  });
                }}
              >
                <View style={styles.optionBoxInnerBox}>
                  <Text style={[GlobalStyles.bodyText, styles.optionText]}>In a relationship</Text>
                  {relationship == "Relationship" ? (
                    <CircleDesign />
                  ) : (
                    <View style={styles.optionCircle}></View>
                  )}
                </View>
              </TouchableOpacity>

              <TouchableOpacity
                onPress={() => {
                  setRelationship("Married");
                  setStaticData((prev: any) => {
                    return {
                      ...prev,
                      userInfo: {
                        ...prev.userInfo,
                        relationshipStatus: "Married",
                      },
                    };
                  });
                }}
              >
                <View style={styles.optionBoxInnerBox}>
                  <Text style={[GlobalStyles.bodyText, styles.optionText]}>Married</Text>
                  {relationship == "Married" ? (
                    <CircleDesign />
                  ) : (
                    <View style={styles.optionCircle}></View>
                  )}
                </View>
              </TouchableOpacity>
            </View>
            <View style={styles.innerBottom}>
              <CheckBox
                disabled={false}
                value={toggleCheckBox}
                onValueChange={(newValue) => setToggleCheckBox(newValue)}
                style={styles.checkBox}
              />
              <Text style={GlobalStyles.bodyText}>Always visible on profile</Text>
            </View>
          </View>
          {/* {question=="likeToDate" && <SelectLikeToDate />} */}
        </View>

        <View style={{ height: 100 }}></View>
      </View>
    </SafeAreaView>
  );
}
